import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Binary Classifier" link="https://anantham.github.io/Stats202/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This project done in R, is part of my Stats202 class which I took when I went to Stanford university in the Summer of 2016. The objective was to determine if a query was relevant (yes/no) to a webpage given 10 signals. The models used was Naive Bayes, Bagging, Random Forest, KNN, Support Vector Machine and Boosting. The project focused more on preprocessing and data selection/transformation.
    </ProjectCard>
    <ProjectCard title="Gaussian Naive Bayes classifier" link="https://anantham.github.io/NaiveBayesKS/" bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)" mdxType="ProjectCard">
I wrote my own code and took a presentation on how the naive bayes classifier works using the Iris flower data set. Basics of probability theory were also covered.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      